'use client';
// import { CashBack } from '@ahamove/icons/order';
import { formatCurrency } from '@ahm/common-helpers';
import { Button, Divider, Group, Stack, Text, rem, Image } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import IconPromoTag from '@/assets/icons/promo-tag.svg';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

type ModalBillingProps = {
  onClose: () => void;
};

export default function ModalBillingDetails({ onClose }: ModalBillingProps) {
  const { estimatedData, paymentMethod: selectedPaymentMethod } =
    useBookingStore((state) => state);

  const tBooking = useTranslations('booking');

  const discountDetails = useMemo(
    () => estimatedData?.data?.discount_details ?? [],
    [estimatedData?.data]
  );

  return (
    <>
      <Stack gap={0}>
        {estimatedData?.data?.weight_price ? (
          <Group justify="space-between" py={12}>
            <Text fw={500} fz={14} c="neutral.5">
              {tBooking('billing.wetight_price')}
            </Text>
            <Text fw={600} c="neutral.7">
              {formatCurrency(estimatedData.data.weight_price)}
            </Text>
          </Group>
        ) : null}
        {discountDetails.length > 0 ? (
          <>
            <Stack gap={8} pb={rem(16)}>
              {discountDetails.map((item, index) =>
                item.is_valid ? (
                  <Group key={index} justify="space-between">
                    <Group gap={8} align="center">
                      <IconPromoTag className="size-4" />
                      <Text fw={600} fz={14} lh={rem(20)} c="neutral.7">
                        {item.description || item.promo_code_id}
                      </Text>
                    </Group>
                    <Text fw={700} fz={14} lh={rem(20)} c="green.6">
                      -{formatCurrency(item.discount_value)}
                    </Text>
                  </Group>
                ) : null
              )}
            </Stack>

            <Divider h={1} bg="neutral.0" py={rem(16)} />
          </>
        ) : null}
        {(estimatedData?.data?.weight_price ??
        (estimatedData?.data?.voucher_discount ?? 0) > 0) ? (
          <Divider h={1} bg="neutral.0" />
        ) : null}
        <Group justify="space-between" py={16}>
          <Stack gap={4}>
            <Text fw={700} fz={16}>
              {tBooking('billing.total_price')}
            </Text>
            <Text fw={500} fz={12} c="neutral.5">
              {tBooking('billing.vat')}
            </Text>
          </Stack>
          <Group mb={12} gap={8}>
            <Image src={selectedPaymentMethod?.icon_url} w={24} h={24} />
            {/* <CashBack width={24} height={24} /> */}
            <Text c="primary.5" fz={20} fw={700}>
              {formatCurrency(estimatedData?.data?.total_price)}
            </Text>
          </Group>
        </Group>
        {estimatedData?.data?.total_cod ? (
          <>
            <Divider h={1} bg="neutral.0" />
            <Group justify="space-between" py={12}>
              <Text fw={500} fz={14} c="neutral.5">
                COD
              </Text>
              <Text fw={600} c="neutral.7">
                <Text c="neutral.7" size="sm" fw={600}>
                  {formatCurrency(estimatedData.data.total_cod)}
                </Text>
              </Text>
            </Group>
          </>
        ) : null}
        <Button size="md" mih={rem(48)} onClick={onClose}>
          {tBooking('billing.got_it')}
        </Button>
      </Stack>
    </>
  );
}
